module.exports = __webpack_public_path__ + "img/9.921ab2dc.jpg";